import { AuthService } from './auth.service';
//import { AUTH_PROVIDERS }      from 'angular2-jwt';
import { provideAuth, AuthHttp, AuthConfig } from 'angular2-jwt';
import { Http, RequestOptions } from '@angular/http';

import { AppComponent } from './app.component';
import { ArcService } from './arc.service';
import { AdminService } from './admin.service';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TopicService } from './topic.service';
import { PageService } from './page.service';
import { SortService } from './sort.service';
import { BatchSearchService } from './batch-search.service';
import { FilterService } from './filter.service';
import { CriterionService } from './criterion.service';
import { SearchTermService } from './search-term.service'
import { RuntimeService } from './runtime.service'
import { PatentService } from './patent.service'
import { DbRecordService } from './db-record.service'
import { ExportParserService } from './export-parser.service'
import { NoteService } from  './note.service';
import { CrossrefService } from  './crossref.service';
import { SearchLogService } from  './search-log.service';
import { TagService } from './tag.service'
import { FileService } from './file.service'
import { SeedService } from './seed.service'
import { LinksPageComponent } from './links-page/links-page.component';
import { routing } from './app.routing';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { PatentMenuComponent } from './patent-menu/patent-menu.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { LoginBoxComponent } from './login-box/login-box.component';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import { ProjectBoxComponent } from './project-box/project-box.component';
import { ProjectSummaryComponent } from './project-summary/project-summary.component';
import { TopicBoxComponent } from './topic-box/topic-box.component';
import { TopicSummaryComponent } from './topic-summary/topic-summary.component';
import { SearchTermBoxComponent } from './search-term-box/search-term-box.component';
import { TagButtonComponent } from './tag-button/tag-button.component';
import { TagPatentMenuComponent } from './tag-patent-menu/tag-patent-menu.component';
import { ProjectDbRecordsComponent } from './project-db-records/project-db-records.component';
import { ProjectDbRecordsStatsComponent } from './project-db-records-stats/project-db-records-stats.component';
import { DbRecordBoxComponent } from './db-record-box/db-record-box.component';
import { EditDbRecordBoxComponent } from './edit-db-record-box/edit-db-record-box.component';
import { TagSortComponent } from './tag-sort/tag-sort.component';
import { PagesBoxComponent } from './pages-box/pages-box.component';
import { TagPageComponent } from './tag-page/tag-page.component';
import { FilterInputComponent } from './filter-input/filter-input.component';
import { TagFilterComponent } from './tag-filter/tag-filter.component';
import { NoteBoxComponent } from './note-box/note-box.component';
import { CriterionSummaryComponent } from './criterion-summary/criterion-summary.component';
import { CriterionItemBoxComponent } from './criterion-item-box/criterion-item-box.component';
import { UploadBoxComponent } from './upload-box/upload-box.component';
import { PatentFamilyComponent } from './patent-family/patent-family.component';
import { SeedBoxComponent } from './seed-box/seed-box.component';
import { BatchSearchBoxComponent } from './batch-search-box/batch-search-box.component';
import { CrossrefBoxComponent } from './crossref-box/crossref-box.component';
import { TopicSelectorComponent } from './topic-selector/topic-selector.component';
import { CrossrefRecordBoxComponent } from './crossref-record-box/crossref-record-box.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AssignedTopicBoxComponent } from './assigned-topic-box/assigned-topic-box.component';
import { TopicFilterComponent } from './topic-filter/topic-filter.component';
import { DbRecordTopicBoxComponent } from './db-record-topic-box/db-record-topic-box.component';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: (() => localStorage.getItem('id_token')),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
  }), http, options);
}

@NgModule({
  declarations: [
    AppComponent,
    LinksPageComponent,
    MainMenuComponent,
    PatentMenuComponent,
    AdminDashboardComponent,
    LoginBoxComponent,
    ProjectDashboardComponent,
    AdminPageComponent,
    ProjectBoxComponent,
    ProjectSummaryComponent,
    TopicBoxComponent,
    TopicSummaryComponent,
    SearchTermBoxComponent,
    TagButtonComponent,
    ProjectDbRecordsComponent,
    ProjectDbRecordsStatsComponent,
    DbRecordBoxComponent,
    TagSortComponent,
    PagesBoxComponent,
    TagPageComponent,
    FilterInputComponent,
    TagFilterComponent,
    TopicFilterComponent,
    NoteBoxComponent,
    CriterionSummaryComponent,
    CriterionItemBoxComponent,
    UploadBoxComponent,
    SeedBoxComponent,
    EditDbRecordBoxComponent,
    PatentFamilyComponent,
    TagPatentMenuComponent,
    BatchSearchBoxComponent,
    CrossrefBoxComponent,
    CrossrefRecordBoxComponent,
    TopicSelectorComponent,
    AssignedTopicBoxComponent,
    TopicFilterComponent,
    DbRecordTopicBoxComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    routing
  ],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    AuthService,
    //    AUTH_PROVIDERS,
    ArcService,
    AdminService,
    ProjectService,
    TopicService,
    PageService,
    NoteService,
    FilterService,
    SortService,
    CriterionService,
    SearchTermService,
    RuntimeService,
    PatentService,
    DbRecordService,
    ExportParserService,
    TagService,
    UtilsService,
    SearchLogService,
    FileService,
    SeedService,
    BatchSearchService,
    CrossrefService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts